<template>
  <b-row class="mx-0 px-0" :class="{'justify-content-end' : message.sender && message.sender._id === getMyInfo._id}">

    <!--  Standard Message  -->
    <b-col
      cols="10"
      md="9"
      xl="8"
      v-if="!message.badge"
      class="spnod-message d-flex"
      :class="{
        'spnod-message--white' : !message.sender || message.sender._id !== getMyInfo._id,
        'spnod-message--flagged' : message.messageFlaggedBy && message.messageFlaggedBy.indexOf(getMyInfo._id) > -1}"
      v-on:click.stop.prevent="toggleFlag(index, $event)"
      @mouseenter="popupIndex = index"
      @mouseleave="popupIndex = -1">

      <!--  Icon  -->
      <span
        class="spnod-message-summary__icon"
        :class="{'fi flaticon-user-2' : !hasAvatar(message)}">
         <img v-if="hasAvatar(message)" :src="getAvatar(message)" width="32" height="32" class="spnod-message__avatar" />
      </span>

      <!--  Message  -->
      <div class="px-2 w-100">

        <!--  Label  -->
        <span v-if="message.sender" class="spnod-message-label spnod-message-label--left">
          {{ message.sender.name + " - " + getSentDate(message)}}
        </span>

        <!--  Body  -->
        <div class="w-100">
          <span class="spnod-message__text" v-html="linkify(message.messageBodyx)"></span>
          <span v-if="message.messageFlaggedBy.indexOf(getMyInfo._id) > -1" class="spnod-message__flag">
            <span class="fi flaticon-flag-2"></span>
          </span>
        </div>
      </div>

      <!--  Ready By Overlay  -->
      <div v-if="popupIndex === index && getMyInfo.hasRoles" class="spnod-message__meta spnod-layout-grid__row">
        <span class="spnod-layout-grid__col spnod-layout-grid__col--10 spnod-message__meta--fullheight">
          Read By:&nbsp;
          <span v-for="(reader, index) in message.readers" :key="index" v-if="message.readers.length > 0">
            <!-- todo: expand this for parent names -->
            <span v-if="reader.readBy === message.client._id && reader.readBy !== getMyInfo._id">
              {{message.client.firstName}} {{message.client.lastName}} - {{getReadByDate(reader)}},
            </span>
            <span v-if="reader.readBy !== message.client._id && reader.readBy !== getMyInfo._id"></span>
            <span v-if="reader.readBy === getMyInfo._id">Me - {{getReadByDate(reader)}}</span>
          </span>
          <span v-if="message.readers.length === 0">
            No-one
          </span>
        </span>
        <span class="spnod-layout-grid__col spnod-layout-grid__col--2 spnod-message__flag">
          <span class="fi flaticon-flag-2"></span>
        </span>
      </div>
    </b-col>

    <!--  Parent Badge  -->
    <b-col v-else cols="10">
      <b-row>
        <p class="spnod-message__badge">{{ message.messageBodyx }}</p>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as moment from 'moment'

export default {
  name: 'MessageBody',
  props: ['message', 'index'],
  data() {
    return {
      popupIndex: -1
    }
  },
  mounted() {
    this.$emit('initScrollListener')
  },
  computed: {
    ...mapGetters(['getMessageThread', 'getMyInfo', 'getMessageParticipants'])
  },
  methods: {
    ...mapActions(['updateMessage']),
    hasAvatar(message) {
      if (!message.sender) return false
      const ppt = this.getMessageParticipants.filter(ppt => {
        return ppt._id === message.sender._id && ppt.profilePic && ppt.profilePic.length
      })
      return !!(ppt.length)
    },
    linkify(inputText) {
      let replacedText
      let replacePattern1, replacePattern2, replacePattern3

      // URLs starting with http://, https://, or ftp://
      replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim
      replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">link</a>')

      // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
      replacePattern2 = /(^|[^/])(www\.[\S]+(\b|$))/gim
      replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">link</a>')

      // Change email addresses to mailto:: links.
      replacePattern3 = /(([a-zA-Z0-9\-_.])+@[a-zA-Z_]+?(\.[a-zA-Z]{2,6})+)/gim
      replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">Mail To</a>')

      return replacedText
    },
    async toggleFlag(index, event) {
      if (event.target.tagName.toLowerCase() === 'a') {
        const href = event.target.getAttribute('href')
        if (href) {
          const win = window.open(encodeURI(href), '_blank')
          win.focus()
        }
      }
      let messageIndex = index
      let messageThread = JSON.parse(JSON.stringify(this.getMessageThread))
      let updatedMessage = messageThread[messageIndex]
      updatedMessage.messageFlaggedBy = updatedMessage.messageFlaggedBy || []
      let flagged = updatedMessage.messageFlaggedBy.findIndex(id => id === this.getMyInfo._id)
      if (flagged !== -1) {
        updatedMessage.messageFlaggedBy.splice(flagged, 1)
      } else {
        updatedMessage.messageFlaggedBy.push(this.getMyInfo._id)
      }
      try {
        await this.updateMessage(updatedMessage)
      } catch (err) {
        console.log(err)
      }
      this.popupIndex = -1
    },
    getSentDate(message) {
      return moment(message.sentDate).format('lll')
    },
    getReadByDate(reader) {
      return moment(reader.readDate).format('lll')
    },
    getAvatar(message) {
      const pptId = message.participants.filter(ppt => {
        if (ppt && message && message.sender && ppt._id === message.sender._id) {
          return ppt._id === message.sender._id
        }
      }).map(ppt => ppt._id)
      const avatar = this.getMessageParticipants.filter(ppt => {
        return ppt._id === pptId[0]
      }).map(ppt => ppt.profilePic)
      return avatar.length > 0 && avatar[0] !== '' ? avatar[0] : null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Messaging/MessageBody.vue?788f9899